import { useState, Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
//import Context from "@ckeditor/ckeditor5-core/src/context";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
//import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import AutoComplete from "src/components/common/autoComplete";
import UserInfo from "src/components/common/userInfo";
import { useMyStore } from "src/components/main/mainStore";
import {
    Select, addDate, objAscSort, handleFilesInput, myAxios, MyFormData, simpleStatusColorCode, 
    scroll, fileSystemSchemaForProjects, pipelineOptions, subPipelineOptions, regionOptions,
    safeParseJson
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function ProjectForm({
    projectManagerEmail, 
    pipeline, 
    subPipeline, 
    stage, 
    projectHashKey, 
    projectNumber, 
    clientProjectNumber, 
    clientPONumber, 
    projectDescription, 
    budgets, 
    laborHours, 
    materialCost, 
    prevailing, 
    cpr, 
    opportunityHashKey, 
    requestorHashKey, 
    region, 
    billingType, 
    days, 
    accurateTime, 
    clientSignatureRequired, 
    sendToClient, 
    projectNotes, 
    location, 
    coords, 
    dirNumber, 
    usaTicketNumber, 
    usaTicketDate, 
    clientName, 
    reportWriterList, 
    nearestMedicalFacility,

    keyword, 
    projectCloseIt, 
    history, 
    projects, 
    PMList, 
    reportNeeded, 
    contactList, 
    orgList, 
    oppoList, 
    oppoHK, 
    setProjects, 
    projectsPerPage, 
    setCurrentPage
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const updateProject = async e => {
        e.preventDefault();
        const eT = e.currentTarget;
        const formData = new MyFormData(eT);
        if(
            (
                formData.get("clientName") !==  formData.get("prevClientName") ||
                formData.get("requestorHashKey") !== requestorHashKey ||
                formData.get("projectNumber") !== projectNumber ||
                formData.get("clientProjectNumber") !== clientProjectNumber
            ) && window.confirm("Do you want to update existing job tags?\n(It may take some time to run if number of job tags are large.)")
       ){
            //---------------------------------------------------------------------
            //-------------------------
            setShowLoader(true);
            const preRes = await myAxios("projects/handlePDF.php", formData);
            setShowLoader(true);
            if(!preRes) return;
            //-------------------------
            const preData = preRes.data;
            const rq = contactList.filter(o => o.contactHashKey === curRequestor)[0];
            const org = orgList.filter(o => o.hashKey === curOrg)[0];
            const newRequestor = `${rq.firstName} ${rq.lastName}`;
            const newClientName = org.name;
            const maxAttempts = 3;
            const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
            const failedJobTags = [];
            let updatedCount = 0;
            let abortJobTagUpdates = false;
            for(let p of preData){
                if(abortJobTagUpdates) break;
                const formData0 = new MyFormData(eT);
                for(let [key, value] of Object.entries(p)){
                    if(key === "travelStartTime" || key === "workStartTime" || key === "workEndTime" || key === "travelEndTime"){
                        formData0.set(key, value.substring(11, 16));
                        formData0.set(key.replace("Time", "Date"), value.substring(0, 10));
                    }else{
                        formData0.set(key, value);
                    }
                }
                // Apply project field updates after copying job-tag data so they are not overwritten.
                formData0.set("requestor", newRequestor);
                formData0.set("requestorName", newRequestor);
                formData0.set("clientName", newClientName);
                formData0.set("action", "Submit");
                formData0.set("form", "jobTag");
                formData0.set("sketches", "[]");
                formData0.set("submitDate", p.jobTagSubmitTime.substring(0, 10));
                const temp = document.createElement("div");
                temp.innerHTML = p.workInstructionDescription;
                formData0.append("workRequestedText", temp.innerText);
                temp.innerHTML = p.workPerformed;
                formData0.append("workPerformedText", temp.innerText);
                temp.innerHTML = p.additionalInfo;
                formData0.append("additionalInfoText", temp.innerText);
                if(p.sign && p.sign !== "false"){
                    const pD = JSON.parse(p.sign); 
                    const canvas = document.createElement("canvas");
                    canvas.width = 900;
                    canvas.height = 300;
                    const context = canvas.getContext("2d");
                    context.clearRect(0, 0, canvas.width, canvas.height);
                    pD.forEach(currentPicData => {
                        context.beginPath();
                        switch(currentPicData.drawMode){
                            case "pen":
                                context.moveTo(currentPicData.data[0].x , currentPicData.data[0].y);
                                currentPicData.data.forEach(step => {
                                    context.lineTo(step.x, step.y);
                                })
                                context.stroke();
                            break;
                            default:
                        }
                    })
                    context.beginPath();
                    formData0.set("signUrl", canvas.toDataURL());
                }
                if(p.sign2 && p.sign2 !== "false"){
                    const pD2 = JSON.parse(p.sign2); 
                    const canvas2 = document.createElement("canvas");
                    canvas2.width = 900;
                    canvas2.height = 300;
                    const context2 = canvas2.getContext("2d");
                    context2.clearRect(0, 0, canvas2.width, canvas2.height);
                    pD2.forEach(currentPicData2 => {
                        context2.beginPath();
                        switch(currentPicData2.drawMode){
                            case "pen":
                                context2.moveTo(currentPicData2.data[0].x , currentPicData2.data[0].y);
                                currentPicData2.data.forEach(step => {
                                    context2.lineTo(step.x, step.y);
                                })
                                context2.stroke();
                            break;
                            default:
                        }
                    })
                    context2.beginPath();
                    formData0.set("sign2Url", canvas2.toDataURL());
                }
                //-------------------------
                let lastError = "Unknown error";
                let succeeded = false;
                for(let attempt = 1; attempt <= maxAttempts; attempt++){
                    setShowLoader(true);
                    const res = await myAxios("workLogs/jT.php", formData0, undefined, undefined, true, { silent: true });
                    setShowLoader(false);
                    if(res && !res.__myAxiosError){
                        succeeded = true;
                        break;
                    }
                    lastError = res?.message || "Request failed";
                    if(res?.fatal){
                        abortJobTagUpdates = true;
                        break;
                    }
                    if(attempt < maxAttempts){
                        await sleep(1000 * attempt);
                    }
                }
                if(succeeded){
                    updatedCount++;
                }else{
                    failedJobTags.push({
                        workLogHashKey: p.workLogHashKey,
                        memberName: p.memberName || p.user || p.realEmail || "Unknown",
                        jobTagSubmitTime: p.jobTagSubmitTime,
                        error: lastError
                    });
                    if(abortJobTagUpdates) break;
                }
                //-------------------------
            }
            if(failedJobTags.length){
                const lines = failedJobTags.map(f =>
                    `- ${f.memberName} | ${f.workLogHashKey} | ${f.jobTagSubmitTime || ""}\n  ${f.error}`
                ).join("\n");
                console.error("Job tag update failures:", failedJobTags);
                window.alert(
                    `Job tag updates finished with errors.\n` +
                    `Updated: ${updatedCount} / ${preData.length}\n` +
                    `Failed: ${failedJobTags.length}` +
                    (abortJobTagUpdates ? `\nStopped early due to a fatal error.` : "") +
                    `\n\n${lines}\n\n` +
                    (abortJobTagUpdates
                        ? `Project was NOT saved. Fix the error and try again.`
                        : `Project will still be saved. Copy/screenshot this list for IT.`)
                );
            }
            if(abortJobTagUpdates) return;
        }
        if(formData.get("prevailing") === "on"){
            formData.set("prevailing", "Yes");
        }else{
            formData.set("prevailing", "No")
        }
        if(formData.get("cpr") === "on"){
            formData.set("cpr", "Yes");
        }else{
            formData.set("cpr", "No");
        }
        //-------------------------
        setShowLoader(true);
        const res = await myAxios("projects/updateProject.php", formData);
        setShowLoader(false);
        if(!res) return;
        //-------------------------
        const thisProject = res.data;
        setProjects(projects.map(project => 
            project.projectHashKey === thisProject.projectHashKey?
            {
                ...thisProject, 
                projectFiles: 
                safeParseJson(thisProject.projectFiles)
            }
            :project
        ));
        history.replace(`/Projects/${projectHashKey}`);
        scroll(thisProject.projectHashKey);
    }
    const createProject = async e => {
        e.preventDefault();
        const formData = new MyFormData(e.currentTarget);
        if(!pending){
            const contracts = formData.getAll("contracts[]");
            const emailRecords = formData.getAll("emailRecords[]");
            const otherAttachments = formData.getAll("otherAttachments[]");
            if((contracts.length === 0) || (contracts.length === 1 && contracts[0].size === 0)){
                window.alert("Contracts are required to upload.");
                return;
            }
            if(emailRecords.length === 0 || (emailRecords.length === 1 && emailRecords[0].size === 0)){
                window.alert("Email Records are required to upload.");
                return;
            }
            if(otherAttachments.length === 0 || (otherAttachments.length === 1 && otherAttachments[0].size === 0)){
                window.alert("Other Attachments are required to upload.");
                return;
            }
        }
        formData.set("fileCategory", JSON.stringify(fileSystemSchemaForProjects));
        if(formData.get("prevailing") === "on"){formData.set("prevailing", "Yes")}else{formData.set("prevailing", "No")}
        if(formData.get("cpr") === "on"){formData.set("cpr", "Yes")}else{formData.set("cpr", "No")}
        //-------------------------
        setShowLoader(true);
        const res = await myAxios("projects/createProject.php", formData);
        setShowLoader(false);
        if(!res) return;
        //-------------------------
        const thisProject = res.data;
        const localProjects = [...projects,
            {
                ...thisProject, 
                projectFiles: 
                safeParseJson(thisProject.projectFiles)
            }
        ];
        setProjects(localProjects);
        history.replace(`/Projects/${thisProject.projectHashKey}`);
        setCurrentPage(Math.ceil(localProjects.length / projectsPerPage));
        setTimeout(() => {
            scroll(thisProject.projectHashKey);
        }, 200);
    }
    const localHandleSubmit = e => {
        if(projectInvalid){
            // if(!window.confirm("This Bess Project Number is duplicated. Still Proceed?")){
            //     return;
            // }
            window.alert("Duplicate BTL.");
            return;
        }
        if(!curOrg){
            window.alert("Please select client name.");
            return;
        }
        if(!curRequestor){
            window.alert("Please select Requestor.");
            return;
        }
        if(keyword === "Edit"){
            updateProject(e);
        }else if(keyword === "Add"){
            createProject(e);
        }
    }
    //--------------------------------------------------------------------------------------------
    const [curUsaTicketDate, setUsaTicketDate] = useState(usaTicketDate ?? "");
    const [projectInvalid, setProjectInvalid] = useState("");
    const [curBTLNumber, setBTLNumber] = useState(projectNumber ?? "");
    const [pending, setPending] = useState(projectNumber === "BTL Pending" ?? false);
    const [curProjectDescription, setProjectDescription] = useState(projectDescription ?? "");
    const [curProjectNotes, setProjectNotes] = useState(projectNotes ?? "");
    const [curPipeline, setPipeline] = useState(pipeline ?? "");
    const [subPipelines, setSubPipelines] = useState(subPipelineOptions[curPipeline] ?? []);
    const [curSubPipeline, setSubPipeline] = useState(subPipeline ?? "");
    const [stages, setStages] = useState(pipelineOptions[curPipeline] ?? []);
    const [curStage, setStage] = useState(stage ?? "");
    const [curLaborHours, setLaborHours] = useState(laborHours ?? "");
    const [curMaterialCost, setMaterialCost] = useState(materialCost ?? "");
    const [curBillingType, setBillingType] = useState(billingType ?? "");
    const [curDays, setDays] = useState(days?? "");
    const [curOrg, setOrg] = useState(clientName ?? "");
    const [curRequestor, setRequestor] = useState(requestorHashKey ?? "");
    const [curReportNeeded, setReportNeeded] = useState(reportNeeded ?? "");
    const [curPrevailing, setPrevailing] = useState(prevailing === "Yes"?"on":"" ?? false);
    const [curCpr, setCpr] = useState(cpr === "Yes"?"on":"" ?? false);
    const [curBudgets, setBudgets] = useState(budgets?JSON.parse(budgets): [{amount: "", start: "", end: ""}]);

    const [newReportTechEmail, setNewReportTechEmail] = useState("");
    const [reports, setReports] = useState([]);
    useEffect(() => {
        let isMounted = true;
        const getData = async() => {
            //---------------------------------------------------------------------
            const formData = new MyFormData();
            formData.append("projectHashKey", projectHashKey);
            setShowLoader(true);
            const resReports = await myAxios("projects/readReports.php", formData);
            if(!isMounted) return;
            setShowLoader(false);
            if(!resReports) return;
            setReports(resReports.data === ""?[]:resReports.data);
            //---------------------------------------------------------------------
        }
        getData();
        return () => {isMounted = false;};
    },[projectHashKey, setShowLoader])
    //--------------------------------------------------------------------------------------------
    return(
        <Modal
            closeIt = {projectCloseIt}
            title = {keyword}
            width = {"80%"}
            handleFormSubmit = {localHandleSubmit}
            actionKey = {keyword}
        >
            <div className = "cssSeperateWhenWide2 pl-3 mb-2">
                <div className = "flex-grow-1 maxWidth-50 mr-3">
                    <h4 className = "my-2">Project Detail</h4>
                    <div className = "rounded border mb-2 p-2">
                        <div className = "d-flex align-items-center">    
                            <label htmlFor = "region" className = "required-field font-weight-bold">Region:</label>
                            <select
                                id = "region"
                                required
                                className = "form-control flex-grow-1 ml-3"
                                name = "region"
                                defaultValue = {region || ""}
                            >
                                <option value = "" disabled>Select</option>
                                {regionOptions.map((o, oi) => <option key = {oi}>{o}</option>)}
                            </select>
                        </div>
                        <div className = "d-flex align-items-center mt-2">    
                            <label htmlFor = "pipeline" className = "required-field font-weight-bold">Pipeline:</label>
                            <select
                                id = "pipeline"
                                required
                                className = "form-control flex-grow-1 ml-3"
                                name = "pipeline"
                                value = {curPipeline}
                                onChange = {e => {
                                    setPipeline(e.currentTarget.value);
                                    if(pipelineOptions[e.currentTarget.value]){
                                        setStages(pipelineOptions[e.currentTarget.value]);
                                        setStage("");
                                        setSubPipelines(subPipelineOptions[e.currentTarget.value] ?? []);
                                        setSubPipeline("");
                                    }else{
                                        setStages([]);
                                    }
                                }}
                            >
                                <option value = "">Select Pipeline</option>
                                {Object.keys(pipelineOptions).filter(thisPipeline => curPipeline === "BESS University Construction Project"? true : thisPipeline !== "BESS University Construction Project").map((thisPipeline, thisPipelineIndex) => <option key = {thisPipelineIndex}>{thisPipeline}</option>)}
                            </select>
                        </div>
                        {subPipelines.length?
                        <div className = "d-flex align-items-center mt-2">    
                            <label htmlFor = "subPipeline" className = "font-weight-bold">Sub Pipeline:</label>
                            <select
                                id = "subPipeline"
                                className = "form-control flex-grow-1 ml-3"
                                name = "subPipeline"
                                value = {curSubPipeline}
                                onChange = {e => {
                                    setSubPipeline(e.currentTarget.value);
                                }}
                            >
                                <option value = "">Select Sub Pipeline</option>
                                {subPipelines.map((thisPipeline, thisPipelineIndex) => <option key = {thisPipelineIndex}>{thisPipeline}</option>)}
                            </select>
                        </div>
                        :<></>}
                        <div className = "d-flex align-items-center mt-2">    
                            <label htmlFor = "reportNeeded" className = "required-field font-weight-bold">Report Needed:</label>
                            <select
                                id = "reportNeeded"
                                required
                                className = "form-control flex-grow-1 ml-3"
                                name = "reportNeeded"
                                value = {curReportNeeded}
                                onChange = {e => {
                                    setReportNeeded(e.currentTarget.value);
                                }}
                            >
                                <option value = "">Select</option>
                                <option>No</option>
                                <option>Yes</option>
                            </select>
                        </div>
                        {curReportNeeded === "Yes"?<>
                        {keyword === "Add"?
                        <>
                        <div className = "d-flex align-items-center mt-2">    
                            <label htmlFor = "reportTechEmail" className = "required-field font-weight-bold">Report Tech:</label>
                            <select
                                id = "reportTechEmail"
                                required
                                className = "form-control flex-grow-1 ml-3"
                                name = "reportTechEmail"
                                defaultValue = {""}
                            >
                                <option value = "">Select</option>
                                {reportWriterList.map((reportWriter, reportWriterIndex) => <option key = {reportWriterIndex} value = {reportWriter.email}>{reportWriter.userName}</option>)}
                            </select>
                        </div>
                        </>
                        :
                        <>
                        <div className = "mt-2">
                            <div className = "font-weight-bold">Existing Report(s) for this Project:</div>
                            {reports.length?
                            <ul className = "mb-0">
                                {reports.map((report, reportIndex) => 
                                <li key = {reportIndex} className = "mt-3">
                                    <UserInfo name = {report.reportTech} email = {report.reportTechEmail}/>
                                    <span className = "ml-2">{report.startDate} ~ {report.endDate}</span>
                                    {report.pdfId?
                                    <a
                                        className = "ml-2 btn btn-primary"
                                        href = {`https://drive.google.com/file/d/${report.pdfId}/view?usp=drivesdk`}
                                        target = "_blank"
                                        rel = "noreferrer"
                                    >
                                        View
                                    </a>
                                    :<></>}
                                    <span className = "ml-2" style = {{color: simpleStatusColorCode[report.status]}}>{report.status}</span>
                                    {report.status === "Created"?
                                    <span className = "ml-2 btn btn-danger" onClick = {async() => {
                                        if(!window.confirm("Are you sure to delete this report shell?")) return;
                                        const formData = new MyFormData();
                                        formData.append("reportHashKey", report.reportHashKey);
                                        formData.append("projectHashKey", projectHashKey);
                                        setShowLoader(true);
                                        const res = await myAxios("projects/deleteNewReport.php", formData);
                                        setShowLoader(false);
                                        if(!res) return;
                                        console.log(res.data);
                                        setReports(res.data);
                                    }}>Delete</span>
                                    :<></>}
                                </li>)}
                            </ul>
                            :
                            <div className = "mt-2">
                                No existing report.
                            </div>
                            }
                            <div className = "border rounded d-flex align-items-center p-2 mt-2">    
                                <label htmlFor = "newReportTechEmail" className = "required-field font-weight-bold">New Report Tech:</label>
                                <select
                                    id = "newReportTechEmail"
                                    className = "form-control flex-grow-1 ml-3"
                                    value = {newReportTechEmail}
                                    onChange = {e => setNewReportTechEmail(e.currentTarget.value)}
                                >
                                    <option value = "">Select</option>
                                    {reportWriterList.map((reportWriter, reportWriterIndex) => <option key = {reportWriterIndex} value = {reportWriter.email}>{reportWriter.userName}</option>)}
                                </select>
                                <span className = "ml-3 btn btn-primary" onClick = {async() => {
                                    if(newReportTechEmail === ""){
                                        window.alert("Select Report Tech First.");
                                        return;
                                    }
                                    if(!window.confirm("Are you sure to add a empty report shell for this project?")) return;
                                    const formData = new MyFormData();
                                    formData.append("projectHashKey", projectHashKey);
                                    formData.append("reportTechEmail", newReportTechEmail);
                                    setShowLoader(true);
                                    const res = await myAxios("projects/addNewReport.php", formData);
                                    setShowLoader(false);
                                    if(!res) return;
                                    setReports(res.data);
                                }}>Add Report</span>
                            </div>
                            
                        </div>
                        </>
                        }
                        </>:<></>}
                        <div className = "d-flex align-items-center mt-2">
                            <label htmlFor = "stage" className = "required-field font-weight-bold">Stage:</label>
                            <select
                                id = "stage"
                                required
                                className = "form-control flex-grow-1 ml-3"
                                name = "stage"
                                value = {curStage}
                                onChange = {e => {
                                    setStage(e.currentTarget.value);
                                }}
                            >
                                <option value = "">Select Stage</option>
                                {stages.filter(stage => curReportNeeded !== "Yes"?stage !== "Report Deliverable":true).map((stage, index) => <option key = {index}>{stage}</option>)}
                            </select>
                        </div>
                        <div className = "d-flex align-items-center mt-2">
                            <input
                                readOnly className = "nodisplay"
                                name = "projectHashKey" value = {projectHashKey || ""}
                            />
                            <label htmlFor = "projectNumber" className = "required-field font-weight-bold">Bess Project Number:</label>
                            <input
                                id = "projectNumber"
                                type = "text"
                                className = "form-control flex-grow-1 ml-3"
                                name = "projectNumber"
                                placeholder = "Bess Project Number" 
                                required 
                                readOnly = {pending}
                                value = {curBTLNumber}  
                                onChange = {e => setBTLNumber(e.currentTarget.value)}
                                onBlur = {async e => {
                                    const target = e.currentTarget.value;
                                    if(target === projectNumber){
                                        return;
                                    }
                                    if(!target){
                                        setProjectInvalid("");
                                        return;
                                    }
                                    const formData = new MyFormData();
                                    formData.append("projectHashKey", projectHashKey || "");
                                    formData.append("projectNumber", target);
                                    //-------------------------
                                    setShowLoader(true);
                                    const res = await myAxios("projects/checkDuplicateProject.php", formData);
                                    setShowLoader(false);
                                    if(!res) return;
                                    //-------------------------
                                    setProjectInvalid(res.data);
                                }}
                            />
                            <input
                                readOnly className = "nodisplay"
                                name = "prevProjectNumber" value = {projectNumber || ""}
                            />
                            <label htmlFor = "projectNumberPending" className = "required-field ml-3">Pending</label>
                            <input
                                id = "projectNumberPending" 
                                type = "checkbox"
                                className = "cssCheckBox ml-2"
                                name = "projectNumber" 
                                value = "yes"
                                defaultChecked = {projectNumber === "BTL Pending"}
                                onChange = {e => {
                                    const target = e.currentTarget.checked;
                                    setPending(target);
                                    if(target){
                                        setProjectInvalid("");
                                        setBTLNumber("BTL Pending");
                                    }else{
                                        setBTLNumber(projectNumber || "");
                                    }
                                }}
                            />
                        </div>
                        {projectInvalid?
                        <div className = "mt-2 d-flex">
                            <span className = "font-weight-bold text-danger">Bess Project Number has already existed in database with <Link to = {`/Projects/${projectInvalid}`}>
                                {projects.length?projects.filter(p => p.projectHashKey === projectInvalid)[0]?.projectName:""}
                            </Link>
                            </span>
                        </div>
                        :<></>}
                        <div className = "d-flex align-items-center mt-2">
                            <label className = "required-field font-weight-bold">Client Name:</label>
                            <div className = "flex-grow-1 ml-3">
                                <Select
                                    defaultValue = {orgList.filter(o => o.hashKey === clientName).map(oo => ({...oo, label: oo.name, value: oo.hashKey}))[0]}
                                    options = {orgList.sort((a, b) => objAscSort(a, b, "name")).map(o => ({...o, label: o.name, value: o.hashKey}))}
                                    onChange = {e => setOrg(e?.value)}
                                />
                                <input 
                                    readOnly className = "nodisplay"
                                    name = "clientName" value = {curOrg}
                                />
                                <input 
                                    readOnly className = "nodisplay"
                                    name = "prevClientName" value = {clientName}
                                />
                            </div>
                        </div>
                        <div className = "d-flex align-items-center mt-2">
                            <label className = "required-field font-weight-bold">Requestor Name:</label>
                            <div className = "flex-grow-1 ml-3">
                                <Select
                                    defaultValue = {contactList.filter(o => o.contactHashKey === requestorHashKey).map(oo => ({...oo, label: `${oo.firstName} ${oo.lastName}`, value: oo.contactHashKey}))[0]}
                                    options = {contactList.sort((a, b) => objAscSort(a, b, "firstName")).filter(c => c.organizationHashKey === curOrg).map(o => ({...o, label: `${o.firstName} ${o.lastName}`, value: o.contactHashKey}))}
                                    onChange = {e => setRequestor(e?.value)}
                                />
                            </div>
                            <input 
                                readOnly className = "nodisplay"
                                name = "requestorHashKey" value = {curRequestor}
                            />
                        </div>
                        <div className = "d-flex align-items-center mt-2">
                            <label htmlFor = "clientProjectNumber" className = "required-field font-weight-bold">Client Project Name / Job Number / PM Number:</label>
                            <input
                                id = "clientProjectNumber"
                                type = "text" 
                                required
                                className = "form-control flex-grow-1 ml-3"
                                name = "clientProjectNumber"
                                placeholder = "Client Project Name / Job Number / PM Number"
                                defaultValue = {clientProjectNumber || ""}
                            />
                            <input
                                readOnly className = "nodisplay"
                                name = "prevClientProjectNumber" value = {clientProjectNumber || ""}
                            />
                        </div>
                        <div className = "d-flex align-items-center mt-2">    
                            <label htmlFor = "projectManagerEmail" className = "required-field font-weight-bold">Project Manager:</label>
                            <select
                                id = "projectManagerEmail"
                                required
                                name = "projectManagerEmail"
                                className = "form-control flex-grow-1 ml-3"
                                defaultValue = {projectManagerEmail || ""}
                            >
                                <option value = "">Select</option>
                                {PMList.map((user, key) => <option key = {key} value = {user.email}>{user.userName}</option>)}
                            </select> 
                        </div>
                        <div className = "d-flex align-items-center mt-2">
                            <label htmlFor = "clientPONumber" className = "font-weight-bold">Client PO:</label>
                            <input
                                id = "clientPONumber"
                                type = "text"
                                className = "form-control flex-grow-1 ml-3"
                                name = "clientPONumber"
                                placeholder = "Client PO"
                                defaultValue = {clientPONumber || ""}
                            />
                        </div>
                        <div className = "d-flex align-items-center mt-2">
                            <label htmlFor = "usaTicketNumber" className = "font-weight-bold">USA Ticket Number:</label>
                            <input
                                id = "usaTicketNumber"
                                type = "text"
                                required = {curPipeline === "Potholing Project"}
                                className = "form-control flex-grow-1 ml-3"
                                name = "usaTicketNumber"
                                placeholder = "USA Ticket Number"
                                defaultValue = {usaTicketNumber || ""}
                            />
                        </div>
                        <div className = "d-flex align-items-center mt-2">
                            <label htmlFor = "usaTicketDate" className = "font-weight-bold">USA Ticket Date:</label>
                            <input
                                id = "usaTicketDate"
                                type = "date"
                                required = {curPipeline === "Potholing Project"}
                                min = "1900-01-01"
                                max = "2999-12-31"
                                className = "form-control flex-grow-1 ml-3"
                                name = "usaTicketDate"
                                value = {curUsaTicketDate}
                                onChange = {e => {
                                    setUsaTicketDate(e.currentTarget.value);
                                }}
                            />
                        </div>
                        <div className = "d-flex align-items-center mt-2">
                            <label className = "font-weight-bold">USA Ticket Expiration Date:</label>
                            <input
                                readOnly
                                type = "date"
                                min = "1900-01-01"
                                max = "2999-12-31"
                                className = "form-control flex-grow-1 ml-3"
                                value = {addDate(curUsaTicketDate, 28)}
                            />
                        </div>
                        <div className = "d-flex align-items-center mt-2">    
                            <label className = "font-weight-bold">Job Site Location:</label>
                            <AutoComplete 
                                className = "ml-3"
                                location = {location}
                                coords = {coords?coords.split(",").map(Number):undefined} 
                                locationName = "location" 
                                coordsName = "coords"
                            />
                        </div>
                        <div className = "d-flex align-items-center mt-2">    
                            <label htmlFor = "nearestMedicalFacility" className = "font-weight-bold">Location of Nearest Medical Facility:</label>
                            <input
                                id = "nearestMedicalFacility"
                                type = "text"
                                className = "form-control flex-grow-1 ml-3"
                                name = "nearestMedicalFacility"
                                defaultValue = {nearestMedicalFacility}
                            />
                        </div>
                        <div className = "d-flex align-items-center mt-2">
                            <label htmlFor = "billingType" className = "font-weight-bold">Billing Type:</label>
                            <select
                                id = "billingType"
                                className = "form-control flex-grow-1 ml-3"
                                name = "billingType"
                                value = {curBillingType}
                                onChange = {e => {
                                    setBillingType(e.currentTarget.value)
                                }}
                            >
                                <option value = "">Select</option>
                                <option>Day Rate</option>
                                <option>T & M</option>
                            </select>
                        </div>
                        {curBillingType === "Day Rate"?
                        <>
                        <div className = "d-flex align-items-center mt-2">
                            <label htmlFor = "days" className = "font-weight-bold">Estimate Days:</label>
                            <input
                                id = "days"
                                type = "number"
                                step = "any"
                                className = "form-control flex-grow-1 ml-3"
                                name = "days"
                                placeholder = "Days"
                                value = {curDays}
                                onChange = {e => {
                                    setDays(e.currentTarget.value);
                                }}
                            />
                        </div>
                        </>:<></>}
                        {curBillingType === "T & M"?<>
                        <div className = "d-flex align-items-center mt-2">
                            <label htmlFor = "laborHours" className = "font-weight-bold">Estimate Labor Hours:</label>
                            <input
                                id = "laborHours"
                                type = "number"
                                step = "any"
                                className = "form-control flex-grow-1 ml-3"
                                name = "laborHours"
                                placeholder = "Labor Hours"
                                value = {curLaborHours}
                                onChange = {e => {
                                    setLaborHours(e.currentTarget.value);
                                }}
                            />
                        </div>
                        <div className = "d-flex align-items-center mt-2">    
                            <label htmlFor = "materialCost" className = "font-weight-bold">Estimate Material Cost:</label>
                            <input
                                id = "materialCost"
                                type = "number"
                                step = "any"
                                className = "form-control flex-grow-1 ml-3"
                                name = "materialCost"
                                placeholder = "Material Cost"
                                value = {curMaterialCost}
                                onChange = {e => {
                                    setMaterialCost(e.currentTarget.value);
                                }}
                            />
                        </div>
                        </>:<></>}
                        <input
                            className = "nodisplay" readOnly
                            name = "budgets" value = {JSON.stringify(curBudgets)}
                        />
                        <label className = "font-weight-bold mt-2">
                            Detail Budget:
                        </label>
                        {curBudgets.map((v, i) => 
                        <div key = {i} className = "cssSeperateWhenWide border rounded pl-2 mt-2 align-items-center overflow-auto">
                            <div className = "mr-2 my-2">
                                <label htmlFor = {`amount ${i}`}>Amount ($):</label>
                                <input
                                    id = {`amount ${i}`}
                                    type = "number"
                                    required = {
                                        curBillingType !== "T & M" || (i > 0 || v.start || v.end || curBudgets.length > 1)
                                    }
                                    step = "0.01"
                                    className = "form-control"
                                    value = {v.amount}
                                    onChange = {e => setBudgets(
                                        [
                                            ...curBudgets.slice(0, i),
                                            {...v, amount: e.currentTarget.value},
                                            ...curBudgets.slice(i + 1),
                                            
                                        ]
                                    )}
                                />
                            </div>
                            <div className = "mr-2 my-2">
                                <label htmlFor = {`start ${i}`}>Start:</label>
                                <input
                                    id = {`start ${i}`}
                                    type = "date"
                                    required = {v.amount}
                                    className = "form-control"
                                    disabled = {i > 0 && !curBudgets[i - 1].endUnknown}
                                    value = {i > 0 && !curBudgets[i - 1].endUnknown?curBudgets[i - 1].end:v.start}
                                    onChange = {e => setBudgets(
                                        [
                                            ...curBudgets.slice(0, i),
                                            {...v, start: e.currentTarget.value},
                                            ...curBudgets.slice(i + 1),
                                            
                                        ]
                                    )}
                                />
                            </div>
                            <div className = "mr-2 my-2">
                                <label htmlFor = {`end ${i}`}>End:</label>
                                <input
                                    id = {`end ${i}`}
                                    type = "date"
                                    required = {v.amount}
                                    disabled = {v.endUnknown}
                                    className = "form-control"
                                    min = {i > 0?curBudgets[i - 1].end:v.start}
                                    value = {v.end}
                                    onChange = {e => setBudgets(
                                        [
                                            ...curBudgets.slice(0, i),
                                            {...v, end: e.currentTarget.value},
                                            ...curBudgets.slice(i + 1),
                                            
                                        ]
                                    )}
                                />
                            </div>
                            <div className = "mr-2 my-2">
                                <label htmlFor = {`end unkown ${i}`} className = "text-nowrap">End Unknown</label>
                                <input
                                    id = {`end unkown ${i}`}
                                    type = "checkbox"
                                    className = "cssCheckBox d-block"
                                    disabled = {i < curBudgets.length - 1}
                                    checked = {v.endUnknown}
                                    onChange = {e => setBudgets(
                                        [
                                            ...curBudgets.slice(0, i),
                                            {...v, 
                                                endUnknown: e.currentTarget.checked,
                                                end: ""
                                            },
                                            ...curBudgets.slice(i + 1),
                                            
                                        ]
                                    )}
                                />
                            </div>
                            {i !== 0?
                            <div className = "ml-2 mr-2">
                                <span
                                    className = "btn btn-danger"
                                    onClick = {() => {
                                        if(!window.confirm("Are you sure to delete this row?")) return;
                                        setBudgets([
                                            ...curBudgets.slice(0, i),
                                            ...curBudgets.slice(i + 1),
                                            
                                        ])
                                    }}
                                >
                                    x
                                </span>
                            </div>:<></>}
                        </div>)}
                        <div className = "mt-2">
                            <span
                                className = "btn btn-primary"
                                onClick = {() => {
                                    setBudgets([...curBudgets.map(x => ({...x, endUnknown: false})), {amount: "", start: "", end: ""}])
                                }}
                            >
                                Add Change Order
                            </span>
                        </div>
                        <div>   
                            <div className = "font-weight-bold mt-2">Description:</div>
                            <div className = "mt-2">
                                <CKEditor
                                    editor = {ClassicEditor}
                                    config = {{
                                        toolbar: [
                                            "selectAll", "undo", "redo", "bold", "italic", 
                                            "numberedList", "bulletedList"
                                        ]
                                    }}        
                                    data = {curProjectDescription}
                                    onChange = {(_, editor) => {
                                        setProjectDescription(editor.getData()); 
                                    }}
                                />
                            </div>
                            <input
                                readOnly className = "nodisplay"
                                name = "projectDescription" value = {curProjectDescription}
                            />
                        </div>
                        <div className = "d-flex align-items-center mt-2">    
                            <label htmlFor = "opportunityHashKey" className = "font-weight-bold">Opportunity:</label>
                            {oppoHK !== undefined?
                            <select
                                id = "opportunityHashKey"
                                readOnly
                                className = "form-control flex-grow-1 ml-3"
                                name = "opportunityHashKey"
                                value = {oppoHK ?? ""}
                            >
                                <option value = "">Select</option>
                                {oppoList.map((oppo, index) => 
                                    <option 
                                        key= {index} 
                                        value = {oppo.opportunityHashKey}
                                    >
                                        {oppo.opportunityName}
                                    </option>
                                )}
                            </select>
                            :
                            <select
                                id = "opportunityHashKey"
                                className = "form-control flex-grow-1 ml-3"
                                name = "opportunityHashKey"
                                defaultValue = {opportunityHashKey || ""}
                            >
                                <option value = "">Select</option>
                                {oppoList.map((oppo, index) => 
                                    <option 
                                        key= {index} 
                                        value = {oppo.opportunityHashKey}
                                    >
                                        {oppo.opportunityName}
                                    </option>
                                )}
                            </select>
                            }
                        </div>
                    </div>
                </div>
                <div className = "flex-grow-1 maxWidth-50">
                    {keyword === "Add"?
                    <>
                        <h4 className = "my-2 ml-2">Attachments</h4>
                        <div className = "rounded border p-2 ml-2">
                            {fileSystemSchemaForProjects.map((schema, schemaIndex) => 
                            <Fragment key = {schemaIndex}>
                                <div>{schema.title}</div>
                                <div className = "custom-file">
                                    <input
                                        type = "file"
                                        className = "custom-file-input"
                                        name = {`${schema.name}[]`}
                                        multiple
                                        onChange = {handleFilesInput}
                                    />
                                    <label className = "custom-file-label">Choose file(s)</label>
                                </div>
                            </Fragment>)}
                        </div>
                    </>
                    :
                    <></>
                    }
                    <h4 className = "my-2 ml-2">Compliance</h4>
                    <div className = "rounded border p-2 ml-2">         
                        <div className = "custom-control custom-switch">
                            <input
                                type = "checkbox"
                                className = "custom-control-input"
                                id = "prevailing"
                                name = "prevailing" 
                                checked = {curPrevailing === "on"}
                                onChange = {e => {
                                    setPrevailing(e.currentTarget.checked?"on":"");
                                    if(e.currentTarget.checked === false){
                                        setCpr(false);
                                    }
                                }}
                            />
                            <label className = "custom-control-label" htmlFor = "prevailing">Prevailing Job</label>
                        </div>
                        {curPrevailing?
                        <div className = "custom-control custom-switch mt-2">
                            <input
                                type = "checkbox"
                                className = "custom-control-input"
                                id = "cpr"
                                name = "cpr" 
                                checked = {curCpr === "on"}
                                onChange = {e => {
                                    setCpr(e.currentTarget.checked?"on":"");
                                }}
                            />
                            <label className = "custom-control-label" htmlFor = "cpr">Certified Payroll Needed</label>
                        </div>:<></>}
                        {curPrevailing && curCpr?
                        <div className = "mt-2">
                            <div className = "d-flex align-items-center">
                                <label htmlFor = "dirNumber">DIR Number:</label>
                                <input
                                    id = "dirNumber"
                                    type = "text"
                                    className = "form-control flex-grow-1 ml-3"
                                    name = "dirNumber"
                                    defaultValue = {dirNumber}
                                />
                            </div>
                            <div className = "mt-2"><a href = "https://www.dir.ca.gov/DAS/DASForm140.pdf" rel = "noopener noreferrer" target = "_blank">DAS 140 Form</a> must be emailed before the job started.</div>
                        </div>:<></>}
                    </div>
                    <h4 className = "my-2 ml-2">Others</h4>
                    <div className = "border rounded p-2 ml-2">
                        <div className = "custom-control custom-switch">
                            <input
                                type = "checkbox"
                                className = "custom-control-input"
                                id = "accurateTime"
                                name = "accurateTime"
                                defaultChecked = {accurateTime === "on"}
                            />
                            <label className = "custom-control-label" htmlFor = "accurateTime">Accurate Time on Job Tag</label>
                        </div>
                        {curPipeline !== "GPR Concrete Scanning and Coring Project"?
                        <>
                        <div className = "custom-control custom-switch mt-2">
                            <input
                                type = "checkbox"
                                className = "custom-control-input"
                                id = "clientSignatureRequired"
                                name = "clientSignatureRequired"
                                defaultChecked = {clientSignatureRequired === "on"}
                            />
                            <label className = "custom-control-label" htmlFor = "clientSignatureRequired">Client Signature Required</label>
                        </div> 
                        <div className = "custom-control custom-switch mt-2">
                            <input
                                type = "checkbox"
                                className = "custom-control-input"
                                id = "sendToClient"
                                name = "sendToClient"
                                defaultChecked = {sendToClient === "on"}
                            />
                            <label className = "custom-control-label" htmlFor = "sendToClient">Send To Client</label>
                        </div>
                        </>
                        :<></>}
                    </div>
                    <h4 className = "my-2 ml-2">Notes</h4>
                    <div className = "mt-2 ml-2">
                        <CKEditor
                            editor = {ClassicEditor}
                            config = {{
                                toolbar: [
                                    "selectAll", "undo", "redo", "bold", "italic", 
                                    "numberedList", "bulletedList"
                                ]
                            }}        
                            data = {curProjectNotes}
                            onChange = {(_, editor) => {
                                setProjectNotes(editor.getData()); 
                            }}
                        />
                        <input
                            readOnly className = "nodisplay"
                            name = "projectNotes" value = {curProjectNotes}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
}